/**
 * Gate de scope PLATFORM (Platform module, Fase 1). Decisión PURA compartida por el
 * `beforeLoad` de `_authenticated/_layout/platform` — mismo criterio que `useAuth.isPlatform`:
 * el usuario opera a nivel Platform (vista multi-tenant del backoffice) si tiene al menos un
 * roleAssignment de scope PLATFORM. Un user tenant/retailer NO debe ver el área /platform/*.
 *
 * Se mantiene como función pura (sin hooks) para testearla aislada y reusarla desde el guard
 * de ruta, igual que `resolveMfaSetupRedirect` (authGuard.ts).
 */
import type { RoleAssignmentInfoLocal } from '../api/types/MeLocal';

/** Ruta a la que rebota un user NO-platform que intenta entrar a /platform/*. */
export const PLATFORM_FALLBACK_PATH = '/me/profile';

/** true si los roleAssignments incluyen al menos un scope PLATFORM (criterio de useAuth.isPlatform). */
export function isPlatformScope(roleAssignments: RoleAssignmentInfoLocal[]): boolean {
    return roleAssignments.some((a) => a.scope === 'PLATFORM');
}
